import React, { PureComponent, Fragment } from 'react';

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";


export default class BiaxialLineChart extends PureComponent {

  constructor(props) {
    super(props);
    
    this.state = { 
        data: this.props.data,
    }

  }

  componentWillReceiveProps = (nextProps) => {
    
    this.setState({
        data : nextProps.data
    });
  }

  
  render() {
    const option = {
        grid : {
            height : this.props.height ?  this.props.height :  'auto'
        },
        tooltip: {
            trigger: 'item',
            formatter: (param) => {
                return  param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)";
            }
        },
        series: {
            type: 'pie',
            data: this.state.data,
            animation: false,
            label: {
                formatter: (param) => {
                    return  param.data.name + " : " + param.data.value.toLocaleString();
                },
                position: 'outer',
                
                margin : '20'
                
            }
        }
    }


    return (
      <ReactEcharts option={option} style={{height : "250px"}}/>
    );
  }
}
